@if ({
  product: product$ | async,
  }; as content) {
  <div class="container-where-to-buy">
    @if (!content.product?.discontinued) {
      <a tabindex="0" [routerLink]="['/where-to-buy']" class="btn btn-primary w-100 btn-where-to-buy">
        <span class="material-symbols-outlined m-r-4"> location_on </span>
        {{ 'productRow.actions.whereToBuy' | cxTranslate }}
      </a>
    }
  </div>
}
